"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiCallHandler = exports.Api = exports.Routes = void 0;
const axios_1 = __importDefault(require("axios"));
const helpers_1 = require("../../commonFiles/helpers");
exports.Routes = {
    dashboard: () => '/dashboard/',
    loginPage: () => '/dashboard/loginPage',
    pageCreator: () => '/dashboard/createPage',
    pagesIndex: () => '/dashboard/pagesIndex',
    pageShow: (id) => id ? '/dashboard/pages/' + id : '/dashboard/pages/:id',
    pageEdit: (id) => id ? '/dashboard/pages/' + id + '/edit' : '/dashboard/pages/:id/edit',
    bookCreator: () => '/dashboard/books/create',
    booksIndex: () => '/dashboard/books',
    bookShow: (id) => id ? '/dashboard/books/' + id : '/dashboard/books/:id',
    bookEdit: (id) => id ? `/dashboard/books/${id}/edit` : '/dashboard/books/:id/edit',
    articleCreator: () => '/dashboard/articles/create',
    articlesIndex: () => '/dashboard/articles',
    articleShow: (id) => id ? '/dashboard/articles/' + id : '/dashboard/articles/:id',
    articleEdit: (id) => id ? '/dashboard/articles/' + id + '/edit' : '/dashboard/articles/:id/edit',
    categoryCreator: () => '/dashboard/categories/create',
    categoriesIndex: () => '/dashboard/categories',
    categoryShow: (id) => id ? '/dashboard/categories/' + id : '/dashboard/categories/:id',
    categoryEdit: (id) => id ? '/dashboard/categories/' + id + '/edit' : '/dashboard/categories/:id/edit',
    glossaryTermCreator: () => '/dashboard/glossaryTermsIndex/create',
    glossaryTermsIndex: () => '/dashboard/glossaryTermsIndex',
    glossaryTermShow: (id) => id ? '/dashboard/glossaryTermsIndex/' + id : '/dashboard/glossaryTermsIndex/:id',
    glossaryTermEdit: (id) => id ? '/dashboard/glossaryTermsIndex/' + id + '/edit' : '/dashboard/glossaryTermsIndex/:id/edit',
};
const apiPrefix = 'dashboardAPI';
exports.Api = {
    home: () => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/home`); }),
    login: (username, password) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.post(`/${apiPrefix}/login`, { username: username, password: password }); }),
    logout: () => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.delete(`/${apiPrefix}/logout`); }),
    getAdmin: () => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/admin`); }),
    fetchBase64DataFromUrl: (url) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/fetchBase64DataFromUrl`, { params: { url: url } }); }),
    translate: (params) => axios_1.default.post(`/${apiPrefix}/translate`, params),
    createPage: (params) => {
        return axios_1.default.post(`/${apiPrefix}/pages`, params);
    },
    editPage: (id, title, about, source_url, page_content, book_id) => {
        return axios_1.default.put(`/${apiPrefix}/pages/` + id, { title: title, about: about, source_url: source_url, page_content: page_content, book_id: book_id });
    },
    fetchPages: (params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/pages`, { params: params }); }),
    fetchPage: (id) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/pages/${id}`); }),
    deletePage: (id) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.delete(`/${apiPrefix}/pages/${id}`); }),
    createBook: (title, description, about, thumbnail, author, activated, content_table) => __awaiter(void 0, void 0, void 0, function* () {
        return yield axios_1.default.post(`/${apiPrefix}/books/create`, {
            title: title, description: description, about: about, thumbnail: thumbnail, author: author, activated: activated, content_table: content_table
        });
    }),
    editBook: (id, title, description, about, thumbnail, author, activated, content_table) => __awaiter(void 0, void 0, void 0, function* () {
        return yield axios_1.default.put(`/dashboardAPI/books/${id}`, {
            title: title, description: description, about: about, thumbnail: thumbnail, author: author, activated: activated, content_table: content_table
        });
    }),
    fetchBooks: (params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/books/`, { params: params }); }),
    fetchBook: (id, params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/books/${id}`, { params: params }); }),
    bookThumbnail: (id) => `/${apiPrefix}/books/${id}/thumbnail`,
    createArticle: (categories_ids, title, description, about, thumbnail, activated, page_content, source_url, posted_on) => __awaiter(void 0, void 0, void 0, function* () {
        return yield axios_1.default.post(`/${apiPrefix}/articles`, {
            title: title,
            description: description,
            about: about,
            thumbnail: thumbnail,
            categories_ids: categories_ids,
            activated: activated,
            page_content: page_content,
            source_url: source_url,
            posted_on: posted_on,
        });
    }),
    fetchArticles: (params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/articles/`, { params: params }); }),
    fetchArticle: (id) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/articles/${id}`); }),
    deleteArticle: (id) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.delete(`/${apiPrefix}/articles/${id}`); }),
    editArticle: (id, categories_ids, title, description, about, thumbnail, activated, page_content, source_url, posted_on) => __awaiter(void 0, void 0, void 0, function* () {
        return yield axios_1.default.put(`/${apiPrefix}/articles/` + id, {
            categories_ids: categories_ids, title: title, description: description, about: about, thumbnail: thumbnail,
            activated: activated, page_content: page_content, source_url: source_url,
            posted_on: posted_on
        });
    }),
    fetchArticleCategories: (id) => axios_1.default.get(`/${apiPrefix}/fetchArticleCategories/${id}`),
    articleThumbnail: (id) => `/${apiPrefix}/articles/${id}/thumbnail`,
    createCategory: (name) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.post(`/${apiPrefix}/categories`, { name: name }); }),
    fetchCategories: (params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/categories/`, { params: params }); }),
    categoryName: (id) => axios_1.default.get(`/${apiPrefix}/categoryName/` + id),
    fetchCategory: (id, params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/categories/${id}`, { params: params }); }),
    editCategory: (id, name) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.put(`/${apiPrefix}/categories/${id}`, { name: name }); }),
    deleteCategory: (id) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.delete(`/${apiPrefix}/categories/${id}`); }),
    createGlossaryTerm: (name) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.post(`/${apiPrefix}/glossaryTerms`, { name: name }); }),
    fetchGlossaryTerms: (params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/glossaryTerms/`, { params: params }); }),
    fetchGlossaryTerm: (id, params) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.get(`/${apiPrefix}/glossaryTerms/${id}`, { params: params }); }),
    editGlossaryTerm: (id, name) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.put(`/${apiPrefix}/glossaryTerms/${id}`, { name: name }); }),
    deleteGlossaryTerm: (id) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.delete(`/${apiPrefix}/glossaryTerms/${id}`); }),
    fetchFromLaitmanBlog: (source_url) => __awaiter(void 0, void 0, void 0, function* () { return yield axios_1.default.post(`/${apiPrefix}/fetchFromLaitmanBlog`, { source_url: source_url }); }),
};
function ApiCallHandler(ApiEndpoint, setData, Identifier, logData = false) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield ApiEndpoint();
            if (setData)
                setData(response.data);
            if (Identifier && logData)
                console.log(Identifier + ':', response.data);
            return response;
        }
        catch (error) {
            (0, helpers_1.logError)(error, Identifier);
            throw error;
        }
    });
}
exports.ApiCallHandler = ApiCallHandler;
